var _title, _g, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRoundedCalendar = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4de4300-4bdd-4d8a-a245-4a55340a3635",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-rounded-calendar-hollow")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    fill: "#333"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 14,
    height: 14,
    rx: 1.5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.25,
    y1: 9,
    x2: 10.25,
    y2: 5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.75,
    y1: 9,
    x2: 17.75,
    y2: 5,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 11,
    x2: 21,
    y2: 11,
    fill: "none",
    stroke: "#333",
    strokeMiterlimit: 10,
    strokeWidth: 1.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.39708,
    y1: 13.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14.29415,
    y1: 15.26393,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 15.0974,
    y1: 17.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 17.69675,
    y1: 17.73607,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 15.26393,
    x2: 16.39708,
    y2: 15.94722,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-calendar.50cd6947.svg";
export { ForwardRef as ReactComponent };